export default {

	// New Account Rrequest - Language Strings

	"title_new_account": "Nouvelle Demande de Compte",
	
	// Account & Rep Section
	"title_account_and_rep_details":"Détails du Compte et du Représentant",
	"label_account_name": "Nom du Compte Commercial",
	"label_business_phone": "Numéro de Téléphone d'Affaires",
	"label_rep_name": "Nom du Rep Saxx",
	"label_rep_email": "Adresse Électronique du Rep Saxx",
	"label_customer_email": "Adresse Électronique du Client",
	"label_account_profile": "Profil de Compte",
	
	// Address Section
	"title_address": "Adresse de Compte",
	"label_country": "Pays",
	"label_province": "Province",
	"label_state": "Etat",
	"label_address_line_1": "Adresse de Compte",
	"label_address_line_2": "Adresse de Compte 2",
	"label_city": "Ville",
	"label_postal_code": "Code Postal",

	// Business Info Section
	"title_business_info": "Informations d'Affaires",
	"label_agency": "Agence",
	"label_channel": "Canal de Distribution",
	"label_retailer_website": "Adresse du site Web du détaillant",
	"label_opening_order_forecast": "Ordre d'Ouverture Prévision $",
	"label_opening_year_forecast": "Année Civile Prévision $",
	"label_percent_of_business_in_apparel": "% des Affaires en Vêtements",
	"label_key_brands": "Marques Clés en Magasin",
	"label_image_inside_store": "Photo Intérieur de Magasin",
	"label_image_outside_store": "Photo Extérieur de Magasin",
	
	// Finally
	"label_submit": "Soumettre",
	"text_new_account_confirmation": "Je vous remercie! Votre demande a été reçue.",


	// Credit Applications
	//
	//
	"title_credit_application": "La Demande de Crédit",

	// Business details section
	"title_business_details": "Informations d'Affaires",
	"label_company_name": "Nom Légal de l'Entreprise",
	"label_trade_name": "Nom Commercial",
	"text_approved_website_address_for_online_selling": "Adresse Web approuvée pour la vente en ligne",
	"label_sales_tax_vat": "Taxe de vente VAT",
	"label_siren_number": "SIREN #",
	"label_resale_certificate_number": "Numéro de Certificat de Revente",
	"label_resale_certificate_upload": "Télécharger Certificat de Revente",
	"text_pst_number_required_for_bc_mb_sk": "Si votre adresse de livraison se trouve en Colombie-Britannique, au Manitoba ou en Saskatchewan, veuillez fournir votre numéro de PST pour être exonéré de la taxe provinciale.",

	// Shipping address different section
	"title_shipping_address": "Adresse de Livraison",
	"label_different_shipping_address": "Adresse de Livraison Différente?",
	"label_shipping_country": "Pays de Livraison",
	"label_shipping_state": "État d'expédition",
	"label_shipping_province": "Province d'expédition",
	"label_shipping_line_1": "Adresse de livraison 1",
	"label_shipping_line_2": "Adresse de livraison 2",

	// Contact Section
	"title_contact": "Coordonnées",
	"label_name_of_owner": "Nom du Propriétaire",
	"label_phone": "Téléphone",
	"label_business_email": "Adresse Électronique du Propriétaire",
	"title_owner": "Propriétaire",

	// Buyer Section
	"title_buyer": "L'acheteur",
	"label_same_buyer_details": "L'acheteur est-il le même??",
	"label_buyer_name": "Nom de l'acheteur",
	"label_buyer_email": "Email de l'acheteur",
	"label_buyer_phone": "Téléphone de l'acheteur",

	// Billing Contact Section
	"title_billing_contact": "Contact de Facturation",
	"label_same_billing_contact_details": "Le contact de facturation est-il le même?",
	"label_billing_name": "Nom",
	"label_billing_email": "Email",

	// Business Section
	"title_business": "Affaires",
	"label_sales_channel": "Canal de vente",

	// Sales Rep Section
	"title_sales_rep": "Représentant commercial",
	"label_sales_rep_name": "Nom",
	"label_sales_rep_email": "Email",

	// Company Info Section
	"title_company_info": "Information sur l'Entreprise",
	"label_company_type": "Type d'Entreprise",
	"label_store_type": "Type de Magasin",
	"label_do_you_rent_or_own": "Louez-vous ou possédez-vous?",
	"option_rent": "Louez",
	"option_own": "Posséder",
	"label_monthly": "Mensuel",
	"label_number_of_years_owned": "Nombre d'années possédées",
	"label_lease_expirey": "Date d'expiration du bail",
	"label_number_of_stores": "Nombre de magasins",

	// Background Section
	"title_background": "Contexte",
	"label_have_filed_for_bankruptcy": "Propriétaire/entreprise a Déjà Déclaré Faillite?",
	"label_when_was_bankruptcy_filed": "Si Oui Quand?",

	// Payment Section
	"title_payment": "Paiement",
	"option_terms_with_saxx": "Conditions avec SAXX",
	"option_prepayment": "Prépaiement",
	"text_prepayment_information": "Pour les termes de prépaiement, le service des comptes clients de SAXX vous enverra un lien vers notre portail de paiement sécurisé pour recueillir les informations relatives à votre carte de crédit.",
	"text_prepayment_note": "Veuillez noter que nous traiterons une préautorisation avec une estimation des frais de transport et des taxes avant d'expédier votre commande. Une fois votre commande expédiée, nous traiterons le paiement du montant final de la facture.",
	"title_payment_term_bank": "Banque",
	"label_payment_bank_name": "Nom de banque",
	"label_payment_bank_contact_name": "Nom du contact bancaire",
	"label_payment_bank_contact_phone": "Téléphone du contact bancaire",

	"label_bank_name": "Nom de banque",
	"label_bank_contact": "Nom du contact bancaire",
	"label_bank_phone": "Téléphone du contact bancairez",
	"title_supplier": "Fournisseuses",
	"label_supplier_name_1": "Nom du fournisseur 1",
	"label_supplier_contact_name_1": "Nom du responsable chez le fournisseur",
	"label_supplier_email_1": "À l'adresse électronique suivante",
	"label_supplier_phone_1": "Numéro de téléphone",
	"label_supplier_name_2": "Nom Du Fournisseur 2",
	"label_supplier_contact_name_2": "À l'adresse électronique suivante",
	"label_supplier_email_2": "À l'adresse électronique suivante",
	"label_supplier_phone_2": "Numéro de téléphone",
	"label_supplier_name_3": "Nom Du Fournisseur 3",
	"label_supplier_contact_name_3": "À l'adresse électronique suivante",
	"label_supplier_email_3": "À l'adresse électronique suivante",
	"label_supplier_phone_3": "Numéro de téléphone",

	// Notifications Section
	"title_notifications": "Notifications",
	"text_notifications_information": "Notifications d'informations, y compris les factures et les confirmations de commande",
	"label_use_same_email_for_confirmation_and_invoices": "Utiliser le même e-mail pour la confirmation de commande et les factures?",
	"label_notification_emails": "E-mails de notification",
	"label_invoice_emails": "E-mails de facturation",
	"label_order_confirmation_emails": "E-mails de confirmation de commande",

	// Terms and Conditions Section
	"title_terms_and_conditions": "Termes et Conditions",
	"list_terms_and_conditions_usa": [
		"Des frais d'intérêt mensuels de 1,5 % s'appliquent aux factures qui ne sont pas payées au plus tard à la date d,échéance.",
		"Des frais de 25,00 $ s'appliquent aux chèques sans provision et aux arrêts de chèques.",
		"Les retours doivent approuvés par un numéro d'autorisation de retour et des frais de manutention et de réapprovisionnement de 15 % s'appliquent aux articles retournés pouvant être vendus.",
		"Les marchandises jugées insatisfaisantes doivent être retournées dans les 72 heures suivant la réception.",
		"En signant la présente demande, l'acheteur accepte que leur couriel soit ajoutée des bulletins d'information mensuels de SAXX.",
		"En signant la présente demande, l'acheteur accepte tout ce qui précède et autorise la vérification des informations de crédit par les entreprises et les institutions financières que l'acheteur a indiquées dans le présent document et d'autres dont Saxx Underwear Co. prend connaissance pendant le processus de vérification du crédit.",
	],
	"list_terms_and_conditions_canada_and_international": [
		"Des frais d'intérêt mensuels de 1,5 % s'appliquent aux factures qui ne sont pas payées au plus tard à la date d,échéance.",
		"Des frais de 25,00 $ s'appliquent aux chèques sans provision et aux arrêts de chèques.",
		"Les retours doivent approuvés par un numéro d'autorisation de retour et des frais de manutention et de réapprovisionnement de 15 % s'appliquent aux articles retournés pouvant être vendus.",
		"Les marchandises jugées insatisfaisantes doivent être retournées dans les 72 heures suivant la réception.",
		"En signant la présente demande, l'acheteur accepte que leur couriel soit ajoutée des bulletins d'information mensuels de SAXX.",
		"En signant la présente demande, l'acheteur accepte tout ce qui précède et autorise la vérification des informations de crédit par les entreprises et les institutions financières que l'acheteur a indiquées dans le présent document et d'autres dont Saxx Underwear Co. prend connaissance pendant le processus de vérification du crédit.",
	],
	"title_vendor_and_map_policies": "SAXX Politique de PMA et Politique Concernant le Vendeur",
	"text_vendor_and_map_policies": "En soumettant cette demande , l'acheteur accepte les politiques suivantes: (Vous recevrez une copie électronique de ces politiques sur approbation de crédit)",
	"label_vendor_policy": "Politique concernant le Vendeur",
	"label_map_policy": "Politique de PMA",
	"title_enter_name_and_position": "Veuillez Indiquer Votre Nom et Votre Poste",
	"text_enter_name_and_position_politely": "Pour authentifier cette soumission , s'il vous plaît remplir votre nom et la position ci-dessous. Je vous remercie!",
	"label_legal_name": "Nom",
	"label_legal_position": "Titre",
	"label_legal_i_agree_to_terms_conditions_policies": "J'accepte les modalités, conditions et politiques",
	
	// Confimation Message
	"text_credit_application_confirmation": "Votre candidature est en cours de traitement, vous en serez informé par e-mail une fois le résultat obtenu.",

};

























